import React from "react";
import { Box, Container } from '@mui/system';
import Grid from '@mui/system/Grid';

const RightElement = ({imgSrc})=>{
    return(
        <>
            <Box>
                <img className="cat-position" src={imgSrc}  alt="Nice To See You" />
            </Box>
        </>
    )
}
export {RightElement}